export default __webpack_public_path__ + "static/media/ddsu5168_2p_product.e07799bb.png";